var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('JqxButton',{ref:"confirmEDI",attrs:{"theme":'material',"width":120,"height":40,"textPosition":'center'},on:{"click":function($event){return _vm.confirmEDIinAttesa()}}},[_vm._v("\n    Conferma EDI\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }